import { useEffect } from 'react';
import { useHookInterfaces } from './useHookInterfaces';
import { useInvokeCommand } from './useInvokeCommand';

export const useStartupHook = () => {
  const { mutate: invokeHookInterface } = useInvokeCommand();

  // Hook interfaces query is disabled when feature flag is disabled.
  const query = useHookInterfaces({
    type: 'launch',
    canInvoke: true,
  });

  useEffect(() => {
    if (query.isSuccess) {
      const first = query.data.results[0];
      if (first) {
        invokeHookInterface({
          hookInterface: first.url,
          payload: {},
        });
      }
    }
  }, [invokeHookInterface, query.data?.results, query.isSuccess]);

  return query;
};
